import { ScrollView, StyleSheet, Text, View } from 'react-native';
import React, { FC, useCallback, useEffect, useState } from 'react';
import PageTitle from '../../components/PageTitle';
import { Footer } from '../../components/Footer';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { ClubServiceLayout } from '../../WebLayout';
import WebView from 'react-native-webview';
import { IS_WEB } from '../../constants/platform';
import OptionsApi from '../../services/api/options.api';
import { Loading } from '../../components';

const Survey: FC = () => {
  const description: string =
    'KCC REGULARLY AIMS TO IMPROVE THEIR SERVICE AND FACILITIES FOR MEMBERS. PLEASE HELP US BY COMPLETING THIS SURVEY.  WE VALUE YOUR FEEDBACK AND THIS WILL HELP US SERVE YOU BETTER. ';
  const isDesktop = useIsDesktop();
  const [surveyUrl, setSurveyUrl] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getSurveyUrl = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await OptionsApi.getOptions();
      setSurveyUrl(res.data.fields.survey_link);
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    getSurveyUrl();
  }, [getSurveyUrl]);

  if (isDesktop()) {
    return (
      <ClubServiceLayout
        title="Survey"
        icon={require('../../assets/survey.png')}
        current={2}
        description={description}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <iframe
            title="KCC Survey Form"
            style={{
              height: 1000,
            }}
            src={surveyUrl}
          ></iframe>
        )}
      </ClubServiceLayout>
    );
  }
  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={styles.container}>
        <PageTitle
          title="Survey"
          icon={require('../../assets/survey.png')}
          description={description}
          haveGoBackButton={true}
        />
        {isLoading ? (
          <View style={{ paddingVertical: 20 }}>
            <Loading />
          </View>
        ) : IS_WEB ? (
          <iframe
            title="KCC Survey Form"
            style={{
              height: 500,
            }}
            src={surveyUrl}
          ></iframe>
        ) : (
          <>
            {/* Disable on website */}
            {/* <WebView
              style={{
                height: 500,
              }}
              scrollEnabled={true}
              nestedScrollEnabled={true}
              source={{ uri: surveyUrl }}
            /> */}
          </>
        )}
      </View>
      <Footer />
    </ScrollView>
  );
};

export default Survey;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
});
